import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UiPopup } from "../common/UiModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { ExpiryPopup } from "../Popups/UIAlertWithDualActionPopup";

export const UiExpiryPassword = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    props?.handleClose(false);
  };

  const handleContinue = () => {
    navigate("/reset-password");
  };

  return (
    <>
      <UiPopup openModal={props?.isOpen}>
        <ExpiryPopup
          icon={<ConfirmationIcon />}
          message={t("Your password has expired")}
          cancelOnclick={handleClose}
          successOnclick={handleContinue}
          cancelText={t("Not Now")}
          continueText={t("Continue")}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            <Trans
              i18nKey={t(
                "It seems your password has expired. To continue accessing your account, you need to create a new password.",
              )}
            />
            <br />
            <br />
            <p>{t("Tap Continue to change your password.")}</p>
          </p>
        </ExpiryPopup>
      </UiPopup>
    </>
  );
};
